export default "__VITE_ASSET__6$8P6wgh__"